import { MONTHS_SHORT_NAME } from '../constants/DateConstants';

export const formatDateddMMYYYYhhmm = function (timestamp) {
    const date = new Date(timestamp);
    const month = date.getMonth();
    const fullYear = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    return `${date.getDate()} ${MONTHS_SHORT_NAME[month]} ${fullYear} - ${hours}:${minutes}`;

};

const addFormat = (data) => {
    return data < 10 ? `0${data}` : data;
};

export const formatDateddmmYYYYhhmm = function (timestamp) {
    const date = new Date(timestamp);
    const fullYear = date.getFullYear();
    const dd = date.getDate();
    const mm = date.getMonth() + 1;
    const hours = date.getHours();
    const minutes = date.getMinutes();
    return `${addFormat(dd)}-${addFormat(mm)}-${fullYear} ${addFormat(hours)}:${addFormat(minutes)}`;
};

export const formatDateCustomized = function (timestamp, dateSeparator: string = '-',
                                                          dateTimeSeparator: string = ' ') {
    const date = new Date(timestamp);
    const fullYear = date.getFullYear();
    const dd = date.getDate();
    const mm = date.getMonth() + 1;
    const hours = date.getHours();
    const minutes = date.getMinutes();
    return `${addFormat(dd)}${dateSeparator}${addFormat(mm)}${dateSeparator}${fullYear}${dateTimeSeparator
    }${addFormat(hours)}:${addFormat(minutes)}`;
};

export const formatDateDayMonthYear = function (dateInput, dateSeparator: string = '-') {
    const date = new Date(dateInput);
    const fullYear = date.getFullYear();
    const dd = date.getDate();
    const mm = date.getMonth() + 1;
    return `${addFormat(dd)}${dateSeparator}${addFormat(mm)}${dateSeparator}${fullYear}`;
};

export const formatDateToMonthDayYear = function (dateInput, dateSeparator: string = '-') {
    const [day, month, year] = dateInput.split(dateSeparator);
    return new Date(year, month - 1, day);
};

export const agesFromBirthday = (birthday) => {
    const nowYear = new Date().getFullYear();
    const birthdayYear = new Date(birthday).getFullYear();
    return nowYear - birthdayYear;
};

export const stringDateToLong = (date, isTruncated = false) => {
    const dateSplit = date.split('-');
    const transformed = new Date();
    transformed.setFullYear(dateSplit[2], dateSplit[1] - 1, dateSplit[0]);
    if (isTruncated) {
        transformed.setHours(0, 0, 0, 0);
    } else {
        transformed.setHours(23, 59, 59, 0);
    }
    return transformed.getTime();
};
